import HeroSection from './components/HeroSection';
import ServiceScopeSection from './components/ServiceScopeSection';
import TechnicalApplicationsSection from './components/TechnicalApplicationsSection';
import StandardsFrameworkSection from './components/StandardsFrameworkSection';
import OperationalFrameworkSection from './components/OperationalFrameworkSection';
import IndustrySectorsSection from './components/IndustrySectorsSection';
import CorporateIdentitySection from './components/CorporateIdentitySection';
import GovernanceSection from './components/GovernanceSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import PageSEO from '../../components/feature/PageSEO';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://arvakon.com';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Arvakon',
    url: siteUrl,
    logo: `${siteUrl}/favicon.ico`,
    description: 'Independent technical verification services for industrial manufacturing supply chains.',
    areaServed: 'International',
    serviceType: 'Third-party technical verification, manufacturing surveillance, welding and NDT oversight',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      url: `${siteUrl}/contact`,
    },
    sameAs: [],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Arvakon',
    url: siteUrl,
  },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-dark-secondary font-sans">
      <PageSEO
        title="Arvakon – Independent Technical Verification for Industrial Manufacturing"
        description="Third-party surveillance services for pressure equipment fabrication, structural steel manufacturing, and protective coating application. Services provided in accordance with ASME, ISO, EN, and NORSOK standards."
        keywords="technical verification, manufacturing surveillance, pressure equipment inspection, industrial quality control, vendor qualification"
        canonical={`${siteUrl}/`}
        ogTitle="Arvakon – Independent Technical Verification for Industrial Manufacturing"
        ogDescription="Third-party surveillance services for pressure equipment fabrication, structural steel manufacturing, and protective coating application."
        ogImage="https://res.cloudinary.com/dvzbmksvl/image/upload/v1772638456/og-image_ap6w4i.png"
        jsonLd={homeJsonLd}
      />
      <HeroSection />
      <ServiceScopeSection />
      <TechnicalApplicationsSection />
      <StandardsFrameworkSection />
      <OperationalFrameworkSection />
      <IndustrySectorsSection />
      <CorporateIdentitySection />
      <GovernanceSection />
      <CTASection />
      <Footer />
    </div>
  );
}